module.exports = __webpack_public_path__ + "img/MichaelFaraday.e4f1b7d0.jpg";